import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { NODE_ENV } from '../config/global.config';
import { invalidateAllTags } from './app.middleware';
import { authReducer } from './features/auth/auth.slice';
import { discloserReducer } from './features/settings/discloser/discloser.slice';
import { filtersReducer } from './features/settings/filters/filters.slice';
import { appService } from './services/app-service';
import { authService } from './services/auth-service';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [authService.reducerPath]: authService.reducer,
    [appService.reducerPath]: appService.reducer,
    auth: authReducer,
    filters: filtersReducer,
    discloser: discloserReducer,
  },
  devTools: NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authService.middleware)
      .concat(appService.middleware)
      .concat(invalidateAllTags([authService, appService])),
});

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
